import * as React from 'react'

const GlobalContext = React.createContext(null)

const GlobalProvider = ({ values, children }) => {
	// header dropdowns
	const [$headerMenu, set$headerMenu] = React.useState(false)

	// mobile menu
	const [mobileMenuState, setMobileMenuState] = React.useState(false)

	// map
	const [$filteredType, set$filteredType] = React.useState(null)

	const value = {
		$headerMenu,
		set$headerMenu,
		mobileMenuState,
		setMobileMenuState,
		$filteredType,
		set$filteredType,
		...values,
	}

	return (
		<GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
	)
}

export { GlobalContext, GlobalProvider }
